export default __webpack_public_path__ + "static/bonus-cards-5c2149b16977e4b764dc4e395741aa50.png";